// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { testimonialsStyles } from "@sc/App/Widgets/Testimonials/Testimonials";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

testimonialsStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        min-height: 265px;
    `,
};

testimonialsStyles.testimonialContainer = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 4px;
        height: 100%;
        width: 100%;
    `,
};
testimonialsStyles.image = {
    css: css`
        border-radius: 4px 4px 0 0;
        background: ${color("common.ui9")};
        width: 100%;
        height: 244px;
        justify-content: flex-start;
        ${xScreen("lte", "md")} {
            height: auto;
            max-height: unset;
        }
        picture[class^="LazyPictureStyle"] {
            width: 100%;
        }
        &&& img {
            width: 100%;
            height: auto;
            max-height: 100%;
        }
    `,
};
testimonialsStyles.dataWrapper = {
    css: css`
        background: ${color("common.ui9")};
        padding: 16px 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        box-sizing: border-box;
        flex-grow: 1;
        ${({ image }: any) => (image ? `border-radius: 0 0 4px 4px;` : `border-radius: 4px;`)}
    `,
};

testimonialsStyles.copyText = {
    size: 16,
    lineHeight: "26px",
    color: "common.white",
    css: css`
        margin-bottom: 0;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    `,
};

testimonialsStyles.autherCompanyWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        gap: 11px;
    `,
};
testimonialsStyles.dataSeparator = {
    css: css`
        display: block;
        max-width: 204px;
        width: 100%;
        height: 1px;
        margin: 20px auto;
        border-top: 1px solid ${color("common.border")};
    `,
};
testimonialsStyles.authorText = {
    size: "16px",
    lineHeight: "26px",
    color: "common.white",
    weight: fontConfig.weight.bold,
    css: css`
        letter-spacing: 0;
    `,
};
testimonialsStyles.companyName = {
    size: "16px",
    lineHeight: "26px",
    color: "common.white",
    weight: fontConfig.weight.bold,
    css: css`
        letter-spacing: 0;
    `,
};
testimonialsStyles.separator = {
    css: css`
        width: 1px;
        height: 26px;
        background: ${color("common.border")};
    `,
};
